<p-dialog
  [(visible)]="visible"
  [closable]="false"
  [header]="dialogTitle"
  [style]="{ width: '600px' }"
  modal
>
  <form [formGroup]="form" class="space-y-4">
    <!-- Nombre -->
    <div>
      <label class="block text-sm font-medium mb-1" for="name">
        {{ 'homologationModule.columns.name' | translate }}
      </label>

      @if (readonly) {
        <div class="px-3 py-2 bg-gray-100 rounded">
          {{ homologation?.name }}
        </div>
      }

      @if (!readonly) {
        <input class="w-full" formControlName="name" id="name" pInputText />
      }
    </div>

    @if (isViewMode || isTooManyRules || isImportMode) {
      <div>
        <p-panel [header]="'homologationModule.rulesTitle' | translate">
          <p-table
            [scrollable]="true"
            [value]="rulesTableData"
            scrollHeight="600px"
            styleClass="text-sm"
          >
            <ng-template pTemplate="header">
              <tr>
                <th scope="col">{{ 'homologationModule.columns.origin' | translate }}</th>
                <th scope="col">{{ 'homologationModule.columns.destiny' | translate }}</th>
              </tr>
            </ng-template>

            <ng-template let-row pTemplate="body">
              <tr>
                <td>{{ row.origin }}</td>
                <td>{{ row.destiny }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td class="text-center text-gray-400 py-6" colspan="2">
                  @if (isImportMode) {
                    {{ 'homologationModule.importWillProcessOnSave' | translate }}
                  } @else {
                    {{ 'homologationModule.noRulesToShow' | translate }}
                  }
                </td>
              </tr>
            </ng-template>
          </p-table>

          @if (isTooManyRules) {
            <p class="text-xs text-gray-500 mt-2">
              {{ 'homologationModule.tooManyRulesViewOnly' | translate: { count: MAX_RULES } }}
            </p>
          }
        </p-panel>
      </div>
    }

    @if (isManualEditable) {
      <div class="space-y-3" formArrayName="rules">
        @for (rule of rules.controls; track rule; let i = $index) {
          <div [formGroupName]="i" class="grid grid-cols-[1fr_1fr_auto] gap-4 items-end">
            <div>
              <label class="block text-sm mb-1" for="origin">
                {{ 'homologationModule.columns.origin' | translate }}
              </label>
              <input class="w-full" formControlName="origin" id="origin" pInputText />
            </div>

            <div>
              <label class="block text-sm mb-1" for="destiny">
                {{ 'homologationModule.columns.destiny' | translate }}
              </label>
              <input class="w-full" formControlName="destiny" id="destiny" pInputText />
            </div>

            @if (rules.length > 1) {
              <p-button
                (click)="removeRule(i)"
                (keydown)="removeRule(i)"
                icon="pi pi-trash"
                severity="danger"
                type="button"
              />
            }
          </div>
        }

        @if (rules.length < MAX_RULES) {
          <p-button
            (click)="addRule()"
            (keydown)="addRule()"
            icon="pi pi-plus"
            [label]="'homologationModule.addRule' | translate"
            severity="secondary"
            styleClass="w-full mt-4"
            type="button"
          />
        }
      </div>
    }

    @if (!readonly) {
      <div class="mt-4">
        <lib-upload-zone
          #uploadZone
          (filesCleared)="onFilesCleared()"
          (filesReady)="onFilesReady($event)"
          [acceptFile]="'.csv,.xls,.xlsx'"
          [allowedExtensions]="allowedExtensions"
          [allowedMimeTypes]="allowedMimeTypes"
          [hideUploadButton]="true"
          [multiple]="false"
          [footerNote]="'homologationModule.allowedFormats' | translate"
          [title]="'homologationModule.fileTitle' | translate"
        />
      </div>
    }
  </form>

  <ng-template pTemplate="footer">
    <div class="mt-4 flex justify-end gap-3">
      <p-button
        (click)="onCancel()"
        (keydown)="onCancel()"
        [label]="'common.cancel' | translate"
        severity="secondary"
      />

      @if (!readonly) {
        <p-button
          (click)="onSave()"
          (keydown)="onSave()"
          icon="pi pi-check"
          [label]="'common.save' | translate"
        />
      }
    </div>
  </ng-template>
</p-dialog>
